module.exports = __webpack_public_path__ + "img/aet.8e21dc05.svg";